/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Fragment } from 'react';
import env from 'env';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from 'components';

export function Edit(props) {
    const id = useParams().id;
    const [atdw, setAtdw] = useState();
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonTrigger, setButtonTrigger] = useState(0);
    const [extraAtdwData, setExtraAtdwData] = useState({
        productId: id,
        displayArea: '',
        mixedListing: false,
        txaCode: '',
        customCategory1: false,
        customCategory2: false,
        customCategory3: false,
        customCategory4: false,
        customCategory5: false,
        customCategory6: false,
        customCategoryTag: '',
    });

    console.log("extraAtdwData", extraAtdwData);

    const handChange = (el => {
        const elName = el.target.name;
        const elValue = el.target.value;
        setExtraAtdwData({ ...extraAtdwData, [elName]: elValue });
    });

    const handChangeForFilter = (el => {
        const value = el.value;
        const categoryCode = el.categoryCode;
        const filterId = el.filterId;

        switch (categoryCode) {
            case 'category_1':
                let _filter1 = extraAtdwData.category_1.filters.find(el => el.filterId === filterId);
                _filter1.checkAtdwProductFilter = value;
                break;
            case 'category_2':
                let _filter2 = extraAtdwData.category_2.filters.find(el => el.filterId === filterId);
                _filter2.checkAtdwProductFilter = value;
                break;
            case 'category_3':
                let _filter3 = extraAtdwData.category_3.filters.find(el => el.filterId === filterId);
                _filter3.checkAtdwProductFilter = value;
                break;
            case 'category_4':
                let _filter4 = extraAtdwData.category_4.filters.find(el => el.filterId === filterId);
                _filter4.checkAtdwProductFilter = value;
                break;
            case 'category_5':
                let _filter5 = extraAtdwData.category_5.filters.find(el => el.filterId === filterId);
                _filter5.checkAtdwProductFilter = value;
                break;
            case 'category_6':
                let _filter6 = extraAtdwData.category_6.filters.find(el => el.filterId === filterId);
                _filter6.checkAtdwProductFilter = value;
                break;
            default:
                break;
        }

        extraAtdwData.customCategory1 = false;
        extraAtdwData.customCategory2 = false;
        extraAtdwData.customCategory3 = false;
        extraAtdwData.customCategory4 = false;
        extraAtdwData.customCategory5 = false;
        extraAtdwData.customCategory6 = false;

        for(let i in extraAtdwData.category_1.filters){
            if(extraAtdwData.category_1.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory1 = true;
                break;
            }
        }

        for(let i in extraAtdwData.category_2.filters){
            if(extraAtdwData.category_2.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory2 = true;
                break;
            }
        }

        for(let i in extraAtdwData.category_2.filters){
            if(extraAtdwData.category_2.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory2 = true;
                break;
            }
        }

        for(let i in extraAtdwData.category_3.filters){
            if(extraAtdwData.category_3.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory3 = true;
                break;
            }
        }

        for(let i in extraAtdwData.category_4.filters){
            if(extraAtdwData.category_4.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory4 = true;
                break;
            }
        }

        for(let i in extraAtdwData.category_5.filters){
            if(extraAtdwData.category_5.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory5 = true;
                break;
            }
        }

        for(let i in extraAtdwData.category_6.filters){
            if(extraAtdwData.category_6.filters[i].checkAtdwProductFilter === true){
                extraAtdwData.customCategory6 = true;
                break;
            }
        }

        setExtraAtdwData({ ...extraAtdwData });
    });

    function onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        //console.log("ddsfdsf", extraAtdwData);
        setPageLoading(true);
        setButtonTrigger(buttonTrigger + 1);
    }

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch(env.apiBase + "/api/atdwadmin/geteditatdw/" + id);
            const data = await res.json();

            setAtdw(data.atdw);
            if (data.exAtdw) {
                setExtraAtdwData({
                    ...data.exAtdw,
                    ...data.atdwFilters,
                    txaCode: data.exAtdw.txaCode ? data.exAtdw.txaCode : ''
                });
            }
            else {
                setExtraAtdwData({
                    ...extraAtdwData,
                    ...data.atdwFilters
                });
            }
        };
        //console.log('extraAtdwData', extraAtdwData);
        fetchData();

        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        if (buttonTrigger === 0) {
            return;
        }
        const fetchData = async () => {
            const res = await fetch(env.apiBase + '/api/atdwadmin/updateatdwextradata', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(extraAtdwData)
            });
            const data = await res.json();
            if (data) { }

            setTimeout(() => {
                setPageLoading(false);
            }, 1000);
        }
        
        fetchData();
        setButtonTrigger(0);

        // eslint-disable-next-line
    }, [buttonTrigger, extraAtdwData]);

    return (
        <Fragment>
            {
                pageLoading ? <Loading></Loading> : (
                    atdw &&
                    <form onSubmit={onSubmit} autoComplete="off">
                        <h2> {atdw.productName} </h2>
                        <hr />
                        <h3 style={{ marginBottom: '0.5rem' }}>ATDW Data</h3>
                        <div>
                            <label>Area : </label>
                            <span style={{ marginLeft: '2rem' }}> {atdw.area} </span>
                        </div>
                        <hr />
                        <h3 style={{ marginBottom: '0.5rem' }}>
                            Update Data
                        </h3>

                        <div className="form-group row">
                            <label htmlFor="username" className="col-sm-2 col-form-label">
                                Display Area
                            </label>
                            <div className="col-sm-5">
                                <select className="form-control" value={extraAtdwData.displayArea} name="displayArea" onChange={handChange}>
                                    <option value=''>{'Use ATDW Area (' + atdw.area + ')'}</option>
                                    <option value='Adelaide'>Adelaide</option>
                                    <option value='Adelaide Hills'>Adelaide Hills</option>
                                    <option value='Barossa'>Barossa</option>
                                    <option value='Clare Valley'>Clare Valley</option>
                                    <option value='Eyre Peninsula'>Eyre Peninsula</option>
                                    <option value='Fleurieu Peninsula'>Fleurieu Peninsula</option>
                                    <option value='Flinders Ranges'>Flinders Ranges</option>
                                    <option value='Kangaroo Island'>Kangaroo Island</option>
                                    <option value='Limestone Coast'>Limestone Coast</option>
                                    <option value='Murraylands'>Murraylands</option>
                                    <option value='Riverland'>Riverland</option>
                                    <option value='Yorke Peninsula'>Yorke Peninsula</option>
                                    <option value='Outback'>Outback</option>
                                </select>
                            </div>
                        </div>
                        <hr />
                        <h3 style={{ marginBottom: '0.5rem' }}>
                            Extra Information
                        </h3>

                        <div className="form-group form-check">
                            <input type="checkbox" className="form-check-input" id="mixedListing" name="mixedListing" checked={extraAtdwData.mixedListing} onChange={(e) => {
                                handChange({ target: { name: "mixedListing", value: e.target.checked } });
                            }} />
                            <label className="form-check-label" htmlFor="mixedListing">
                                Mixed listing
                            </label>
                        </div>

                        <hr />

                        <h3 style={{ marginBottom: '0.5rem' }}>
                            TXA Code
                        </h3>
                        <div className="form-group" style={{ maxWidth: '350px' }}>
                            <input type="text" placeholder="" autoComplete="off" value={extraAtdwData.txaCode} className="form-control" id="txaCode" name="txaCode" onChange={(e) => {
                                handChange({ target: { name: "txaCode", value: e.target.value } });
                            }} />
                        </div>
                        <hr />

                        <h3 style={{ marginBottom: '0.5rem' }}>
                            Custom Categories
                        </h3>

                        {/* <div className="form-group form-check">
                            <div className='container' style={{ margin: 'unset' }}>
                                <label className="checkbox-inline form-check-label" htmlFor="customCategory1">
                                    <input type="checkbox" className="form-check-input" id="customCategory1" name="customCategory1" checked={extraAtdwData.customCategory1} onChange={(e) => {
                                        handChange({ target: { name: "customCategory1", value: e.target.checked } });
                                    }} />
                                    Family Friendly
                                </label>
                                <label className="checkbox-inline form-check-label" htmlFor="customCategory2">
                                    <input type="checkbox" className="form-check-input" id="customCategory2" name="customCategory2" checked={extraAtdwData.customCategory2} onChange={(e) => {
                                        handChange({ target: { name: "customCategory2", value: e.target.checked } });
                                    }} />
                                    Waterfront
                                </label>
                                <label className="checkbox-inline form-check-label" htmlFor="customCategory3">
                                    <input type="checkbox" className="form-check-input" id="customCategory3" name="customCategory3" checked={extraAtdwData.customCategory3} onChange={(e) => {
                                        handChange({ target: { name: "customCategory3", value: e.target.checked } });
                                    }} />
                                    Bush
                                </label>
                                <label className="checkbox-inline form-check-label" htmlFor="customCategory4">
                                    <input type="checkbox" className="form-check-input" id="customCategory4" name="customCategory4" checked={extraAtdwData.customCategory4} onChange={(e) => {
                                        handChange({ target: { name: "customCategory4", value: e.target.checked } });
                                    }} />
                                    Style
                                </label>
                                <label className="checkbox-inline form-check-label" htmlFor="customCategory5">
                                    <input type="checkbox" className="form-check-input" id="customCategory5" name="customCategory5" checked={extraAtdwData.customCategory5} onChange={(e) => {
                                        handChange({ target: { name: "customCategory5", value: e.target.checked } });
                                    }} />
                                    EV
                                </label>
                            </div>
                        </div> */}

                        <div className="form-group row">
                            <div className='col-sm-2'>
                                <div className='container' style={{ margin: 'unset', paddingLeft: '22px' }}>
                                    <label className="checkbox-inline form-check-label" htmlFor="customCategory1">
                                        {/* <input type="checkbox" className="form-check-input" id="customCategory1" name="customCategory1" checked={extraAtdwData.customCategory1} onChange={(e) => {
                                            handChange({ target: { name: "customCategory1", value: e.target.checked } });
                                        }} /> */}
                                        Family Friendly
                                    </label>
                                </div>
                                {
                                    extraAtdwData.category_1 && extraAtdwData.category_1.filters.length > 0 &&
                                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ebebeb' }}>
                                        {extraAtdwData.category_1.filters.map((item, index) =>
                                            <div key={index} className='container' style={{ margin: 'unset', marginTop: '0.3rem', marginBottom: '0.3rem' }}>
                                                <label className="checkbox-inline form-check-label" htmlFor={item.filterId}>
                                                    <input type="checkbox" className="form-check-input" id={item.filterId} name={item.filterId} checked={item.checkAtdwProductFilter} onChange={(e) => {
                                                        handChangeForFilter({
                                                            filterId: item.filterId,
                                                            value: e.target.checked,
                                                            categoryCode: 'category_1'
                                                        });
                                                    }} />
                                                    {item.filterName}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>

                            <div className='col-sm-2'>
                                <div className='container' style={{ margin: 'unset', paddingLeft: '22px' }}>
                                    <label className="checkbox-inline form-check-label" htmlFor="customCategory2">
                                        {/* <input type="checkbox" className="form-check-input" id="customCategory2" name="customCategory2" checked={extraAtdwData.customCategory2} onChange={(e) => {
                                            handChange({ target: { name: "customCategory2", value: e.target.checked } });
                                        }} /> */}
                                        Waterfront
                                    </label>
                                </div>
                                {
                                    extraAtdwData.category_2 && extraAtdwData.category_2.filters.length > 0 &&
                                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ebebeb' }}>
                                        {extraAtdwData.category_2.filters.map((item, index) =>
                                            <div key={index} className='container' style={{ margin: 'unset', marginTop: '0.3rem', marginBottom: '0.3rem' }}>
                                                <label className="checkbox-inline form-check-label" htmlFor={item.filterId}>
                                                    <input type="checkbox" className="form-check-input" id={item.filterId} name={item.filterId} checked={item.checkAtdwProductFilter} onChange={(e) => {
                                                        handChangeForFilter({
                                                            filterId: item.filterId,
                                                            value: e.target.checked,
                                                            categoryCode: 'category_2'
                                                        });
                                                    }} />
                                                    {item.filterName}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>

                            <div className='col-sm-2'>
                                <div className='container' style={{ margin: 'unset', paddingLeft: '22px' }}>
                                    <label className="checkbox-inline form-check-label" htmlFor="customCategory3">
                                        {/* <input type="checkbox" className="form-check-input" id="customCategory3" name="customCategory3" checked={extraAtdwData.customCategory3} onChange={(e) => {
                                            handChange({ target: { name: "customCategory3", value: e.target.checked } });
                                        }} /> */}
                                        Bush
                                    </label>
                                </div>
                                {
                                    extraAtdwData.category_3 && extraAtdwData.category_3.filters.length > 0 &&
                                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ebebeb' }}>
                                        {extraAtdwData.category_3.filters.map((item, index) =>
                                            <div key={index} className='container' style={{ margin: 'unset', marginTop: '0.3rem', marginBottom: '0.3rem' }}>
                                                <label className="checkbox-inline form-check-label" htmlFor={item.filterId}>
                                                    <input type="checkbox" className="form-check-input" id={item.filterId} name={item.filterId} checked={item.checkAtdwProductFilter} onChange={(e) => {
                                                        handChangeForFilter({
                                                            filterId: item.filterId,
                                                            value: e.target.checked,
                                                            categoryCode: 'category_3'
                                                        });
                                                    }} />
                                                    {item.filterName}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>

                            <div className='col-sm-2'>
                                <div className='container' style={{ margin: 'unset', paddingLeft: '22px' }}>
                                    <label className="checkbox-inline form-check-label" htmlFor="customCategory4">
                                        {/* <input type="checkbox" className="form-check-input" id="customCategory4" name="customCategory4" checked={extraAtdwData.customCategory4} onChange={(e) => {
                                            handChange({ target: { name: "customCategory4", value: e.target.checked } });
                                        }} /> */}
                                        Style
                                    </label>
                                </div>
                                {
                                    extraAtdwData.category_4 && extraAtdwData.category_4.filters.length > 0 &&
                                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ebebeb' }}>
                                        {extraAtdwData.category_4.filters.map((item, index) =>
                                            <div key={index} className='container' style={{ margin: 'unset', marginTop: '0.3rem', marginBottom: '0.3rem' }}>
                                                <label className="checkbox-inline form-check-label" htmlFor={item.filterId}>
                                                    <input type="checkbox" className="form-check-input" id={item.filterId} name={item.filterId} checked={item.checkAtdwProductFilter} onChange={(e) => {
                                                        handChangeForFilter({
                                                            filterId: item.filterId,
                                                            value: e.target.checked,
                                                            categoryCode: 'category_4'
                                                        });
                                                    }} />
                                                    {item.filterName}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>

                            <div className='col-sm-2'>
                                <div className='container' style={{ margin: 'unset', paddingLeft: '22px' }}>
                                    <label className="checkbox-inline form-check-label" htmlFor="customCategory5">
                                        {/* <input type="checkbox" className="form-check-input" id="customCategory5" name="customCategory5" checked={extraAtdwData.customCategory5} onChange={(e) => {
                                            handChange({ target: { name: "customCategory5", value: e.target.checked } });
                                        }} /> */}
                                        EV
                                    </label>
                                </div>
                                {
                                    extraAtdwData.category_5 && extraAtdwData.category_5.filters.length > 0 &&
                                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ebebeb' }}>
                                        {extraAtdwData.category_5.filters.map((item, index) =>
                                            <div key={index} className='container' style={{ margin: 'unset', marginTop: '0.3rem', marginBottom: '0.3rem' }}>
                                                <label className="checkbox-inline form-check-label" htmlFor={item.filterId}>
                                                    <input type="checkbox" className="form-check-input" id={item.filterId} name={item.filterId} checked={item.checkAtdwProductFilter} onChange={(e) => {
                                                        handChangeForFilter({
                                                            filterId: item.filterId,
                                                            value: e.target.checked,
                                                            categoryCode: 'category_5'
                                                        });
                                                    }} />
                                                    {item.filterName}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>

                            <div className='col-sm-2'>
                                <div className='container' style={{ margin: 'unset', paddingLeft: '22px' }}>
                                    <label className="checkbox-inline form-check-label" htmlFor="customCategory6">
                                        {/* <input type="checkbox" className="form-check-input" id="customCategory5" name="customCategory5" checked={extraAtdwData.customCategory5} onChange={(e) => {
                                            handChange({ target: { name: "customCategory5", value: e.target.checked } });
                                        }} /> */}
                                        Pet Friendly
                                    </label>
                                </div>
                                {
                                    extraAtdwData.category_6 && extraAtdwData.category_6.filters.length > 0 &&
                                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ebebeb' }}>
                                        {extraAtdwData.category_6.filters.map((item, index) =>
                                            <div key={index} className='container' style={{ margin: 'unset', marginTop: '0.3rem', marginBottom: '0.3rem' }}>
                                                <label className="checkbox-inline form-check-label" htmlFor={item.filterId}>
                                                    <input type="checkbox" className="form-check-input" id={item.filterId} name={item.filterId} checked={item.checkAtdwProductFilter} onChange={(e) => {
                                                        handChangeForFilter({
                                                            filterId: item.filterId,
                                                            value: e.target.checked,
                                                            categoryCode: 'category_6'
                                                        });
                                                    }} />
                                                    {item.filterName}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>

                        </div>

                        {/* <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                            <div style={{ display: 'inline-block' }}>
                                Custom Category Tag :
                            </div>
                            <div className="form-group" style={{ maxWidth: '350px', display: 'inline-block', marginLeft: '1rem' }}>
                                <input type="text" placeholder="" autoComplete="off" value={extraAtdwData.customCategoryTag} className="form-control" id="customCategoryTag" name="customCategoryTag" onChange={(e) => {
                                    handChange({ target: { name: "customCategoryTag", value: e.target.value } });
                                }} />
                            </div>
                        </div> */}

                        <hr />

                        <button type="submit" className="btn btn-primary"> Save </button>
                    </form>
                )
            }
        </Fragment>
    )
}

